export enum LayoutVariant {
  Default = "default",
  Transparent = "transparent",
}
